function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_6060_13967)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M29.5254 33.29H5.9548C5.52437 33.2935 5.09748 33.212 4.69864 33.05C4.2998 32.8881 3.93687 32.649 3.63066 32.3465C3.32445 32.044 3.081 31.684 2.91428 31.2871C2.74756 30.8902 2.66086 30.4644 2.65913 30.0339V17.6949C2.65912 17.2634 2.74455 16.8361 2.91049 16.4377C3.07644 16.0393 3.31961 15.6778 3.62599 15.3738C3.93237 15.0699 4.2959 14.8296 4.6956 14.6669C5.09529 14.5042 5.52326 14.4222 5.9548 14.4256H29.5254",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.0716 14.4256C40.9386 14.4256 41.7702 14.77 42.3833 15.3832C42.9964 15.9963 43.3409 16.8278 43.3409 17.6949V30.0339C43.3374 30.8987 42.9914 31.7268 42.3787 32.3371C41.7659 32.9474 40.9364 33.29 40.0716 33.29V33.29",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.4953 20.081L10.6742 27.806L7.83992 20.081",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.887 20.081V27.806L20.2448 20.081V27.806",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.8701 20.081V27.806",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.7985 30.8248C34.2426 30.8248 33.7094 31.0457 33.3164 31.4387C32.9233 31.8318 32.7024 32.365 32.7024 32.9209C32.7444 33.4498 32.9841 33.9435 33.3738 34.3035C33.7635 34.6635 34.2745 34.8635 34.8051 34.8635C35.3356 34.8635 35.8467 34.6635 36.2364 34.3035C36.6261 33.9435 36.8658 33.4498 36.9077 32.9209V32.9209C36.9042 32.3638 36.6805 31.8307 36.2853 31.4379C35.8901 31.0452 35.3556 30.8248 34.7985 30.8248V30.8248Z",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.8079 14.6365V25.6836C32.7757 25.9625 32.8027 26.245 32.8874 26.5126C32.972 26.7803 33.1124 27.027 33.2991 27.2365C33.4858 27.4461 33.7148 27.6139 33.9709 27.7287C34.2271 27.8435 34.5046 27.9029 34.7853 27.9029C35.066 27.9029 35.3436 27.8435 35.5997 27.7287C35.8558 27.6139 36.0848 27.4461 36.2715 27.2365C36.4583 27.027 36.5986 26.7803 36.6832 26.5126C36.7679 26.245 36.795 25.9625 36.7627 25.6836V14.6365C36.795 14.3577 36.7679 14.0752 36.6832 13.8075C36.5986 13.5399 36.4583 13.2932 36.2715 13.0836C36.0848 12.874 35.8558 12.7063 35.5997 12.5914C35.3436 12.4766 35.066 12.4172 34.7853 12.4172C34.5046 12.4172 34.2271 12.4766 33.9709 12.5914C33.7148 12.7063 33.4858 12.874 33.2991 13.0836C33.1124 13.2932 32.972 13.5399 32.8874 13.8075C32.8027 14.0752 32.7757 14.3577 32.8079 14.6365V14.6365Z",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_6060_13967"
}, /*#__PURE__*/React.createElement("rect", {
  width: 42,
  height: 23.7156,
  fill: "white",
  transform: "translate(2 12)"
})));
function SvgVinMismatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVinMismatch);
export default __webpack_public_path__ + "static/media/vin-mismatch.27f392d1ed8fe84f03eef1ba2a425120.svg";
export { ForwardRef as ReactComponent };